import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme) => ({
  body: {
    "& .MuiPaper-root": {
      backgroundColor: theme.design.color.surface.raised,
      color: theme.design.color.text.primary,
      display: "flex",
      flexDirection: "column",
      borderRadius: theme.design.radius.xl,
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      gap: theme.design.space.sm,

      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
  },

  modalContent: {
    position: "relative",
  },

  contentBody: {
    display: "flex",
    flexDirection: "column",
    gap: theme.design.space.lg,
    padding: "32px 56px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 22px",
    },
  },

  closeIconBody: {
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    right: 25,
    top: 25,
    "&>button": {
      padding: 0,
      minWidth: "auto",
      "&>svg": {
        color: theme.design.color.text.secondary,
        cursor: "pointer",
        transition: ".3s",
        width: theme.design.size.icon.lg,
        height: theme.design.size.icon.lg,
        "&:hover": {
          color: theme.design.color.text.primary,
          transition: ".3s",
        },
      },
    },
  },

  logoImg: {
    width: 48,
  },

  titleText: {
    fontSize: 24,
  },

  description: {
    textAlign: "center",
    maxWidth: 400,
    marginTop: 8,
  },

  confirmBut: {
    minWidth: 160,
    borderRadius: theme.design.radius.md,
    background: theme.design.gradient.action.primary,
    textDecoration: "none",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    marginTop: 16,
    textTransform: "none",
  },
}));

export default styles;
